import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractService } from '../commons/abstract.service';
import { ApisLogging } from '../models/apis-logging.model';
import { Observable } from 'rxjs';
import { Pager, SearchParams } from '../../public-api';

@Injectable({ providedIn: 'root' })
export class ApisLoggingService extends AbstractService<ApisLogging> {

  getURLBase(): string {
    return '/apis/apis-logging';
  }

  constructor(private http: HttpClient) {
    super(http);
  }

  preCreate(obj: ApisLogging): void {
    delete obj?._id;
  }
  preUpdate(obj: ApisLogging): void {
  }

  getLoggingsReport(page: number, perPage: number, search?: string, params?: Partial<SearchParams>): Observable<Pager<ApisLogging>> {
    const baseURL = `/report`;
    const pager = `${baseURL}?page=${page}&perPage=${perPage}`;


    const getSearchConfig = (search: string): string => {
      if (!!search) {
        if (search.includes('+')) {
          const searches = search.split('+');
          let urlSearches = '';
          searches.forEach((search) => {
            urlSearches += `&search=${search}`;
          });
          return urlSearches;
        } else {
          return '&search=' + search;
        }
      } else {
        return '';
      }
    }
    const searching = `${pager}${getSearchConfig(search)}`;

    let urling = `${searching}`;
    if (!!params) {
      for (let param in params) {
        urling = `${urling}&${param}=${params[param]}`;
      }
    }
    return super.get(urling);
  }

}
